import React from 'react';

function Footer() {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      // Pokud tam máš ten tvůj smoother-script, 
      // zkusíme nejdřív říct jemu, aby odroloval plynule
      if (window.ScrollSmoother) {
        const smoother = window.ScrollSmoother.get();
        if (smoother) {
          smoother.scrollTo(element, true, "top top");
          return;
        }
      }

      // Fallback: nativní plynulý scroll (pokud smoother neběží)
      const offset = 80; // Výška tvého navbaru, aby ti to nepřekrylo nadpis
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Pokud je menu otevřené na mobilu, zavřeme ho
      document.querySelector('.navbar-collapse')?.classList.remove('show');
    }
  };
  return (
    <footer className="clean-footer crev">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="logo icon-img-120 md-mb80">
              <img src="/assets/imgs/zonya/ZonyaTech_logo_bg_red_white.png" alt="" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Contact</h6>
              <h6 className="p-color fw-400">
                Bohuslava Martinů 814/7 <br /> Ostrava-Poruba
                <br />
                <br />IČO: 24552500  
              </h6>
              <h6 className="mt-30 mb-15">
                <a href="#0">info@zonyatech.com</a>
              </h6>
              <a href="tel:+420604286149" className="underline">
                <span className="fz-22 main-color">+420 604 286 149</span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Useful Links</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <a href="/#">Home</a>
                </li>
                <li className="mb-15">
                  <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>Introduce</a>
                </li>
                <li className="mb-15">
                  <a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Services</a>
                </li>
                <li className="mb-15">
                  <a href="#team" onClick={(e) => scrollToSection(e, 'team')}>Out team</a>
                </li>
                <li>
                  <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-30">Social Links</h6>
              {/* <div className="form-group mb-40">
                <input type="text" name="subscrib" placeholder="Your Email" />
                <button>
                  <span className="ti-location-arrow"></span>
                </button>
              </div> */}
              <ul className="rest social-icon d-flex align-items-center">
                {/* <li className="hover-this cursor-pointer">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-dribbble"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li> */}
                <li className="hover-this cursor-pointer">
                  <a href="mailto:info@zonyatech.com" className="hover-anim">
                    <i className="fas fa-at"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="https://www.instagram.com/zonya_tech/" target='_blank' className="hover-anim">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="tel:+420604286149" className="hover-anim">
                    <i className="fas fa-phone"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © 2026 Proudly crafted by{' '}
                  
              <span className="underline main-color"><a href="https://zonyatech.com">ZonyaTech</a></span>
            </p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
